import { t } from "i18next";

export interface IProps {
  onClickForCancelBtn: () => void;
  openDelete: boolean;
}

function DeleteOfferPopup(props: IProps) {
  return (
    <>
      {props.openDelete && (
        <div className="fixed top-0 z-50 left-0 inset-y-0 inset-x-0 mx-auto my-auto rounded-2xl bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_10px_0px] max-w-[505px] mobile:w-[calc(100vw-98px)] h-fit p-8">
          <div className="flex flex-col gap-6">
            <div className="text-[#435363] font-arBold text-xl mobile:text-base">
              {t("deleteOfferPopup.component.deleteOffer")}
            </div>
            <div className="text-zinc-700 font-arMedium text-xl mobile:text-sm">
              {t("deleteOfferPopup.component.deleteOfferConformationMessage")}
            </div>
            <div className="flex flex-row justify-center gap-6 mobile:gap-1">
              <button className="flex justify-center items-center bg-red-500 h-11 w-52 rounded-2xl text-white font-arBold text-xl mobile:text-base">
                {t("deleteOfferPopup.component.yesDelete")}
              </button>
              <button
                onClick={props.onClickForCancelBtn}
                className="flex justify-center items-center bg-mint-500 h-11 w-52 rounded-2xl text-white font-arBold text-xl mobile:text-base"
              >
                {t("deleteOfferPopup.component.cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DeleteOfferPopup;
